import { trendAxisRange, trendMeasurementType } from "@/lib/body-measurements";
import type { BodyMeasurementTrendConfig } from "@/lib/schema";
import type { WidgetValidationResult } from "@/widgets/types";

export function validate(
  config: BodyMeasurementTrendConfig,
): WidgetValidationResult {
  const errors: Record<string, string> = {};
  if (config.label.trim().length === 0) {
    errors.label = "Etikett kan ikke være tom.";
  }
  // No "pick at least one" rule any more: one measurement per widget, and
  // the radio always has a selection.
  const { unit } = trendMeasurementType(config);
  const range = trendAxisRange(config, unit);
  if (range) {
    const hasMinimum = Number.isFinite(range.minimum);
    const hasMaximum = Number.isFinite(range.maximum);
    if (!hasMinimum || !hasMaximum) {
      errors[`axis-${unit}`] =
        "Fyll inn både minimum og maksimum, eller la begge stå tomme.";
    } else if (range.minimum >= range.maximum) {
      errors[`axis-${unit}`] = "Minimum må være mindre enn maksimum.";
    }
  }
  if (Object.keys(errors).length === 0) return { ok: true };
  return { ok: false, errors };
}
